export type AuthorizeNetEvent =
  | { action: 'successfulSave' }
  | { action: 'cancel' }
  | { action: 'resizeWindow'; width: string; height: string }
  | { action: 'transactResponse' }
  | { action: 'error'; errorMessage?: string }
  | { action: string; [key: string]: any };

export type AuthorizeNetEventListener = (event: AuthorizeNetEvent, rawEvent: MessageEvent) => void;

const allowedOrigins = [
  "http://localhost:3000",
  "https://devapi.wolfpack.com",
  "https://test.authorize.net",
  "https://accept.authorize.net",
  "https://secure.authorize.net"
];

const listeners: Set<AuthorizeNetEventListener> = new Set();

function parseQueryString(str: string): Record<string, string> {
  const vars: Record<string, string> = {};
  const arr = str.split('&');
  for (let i = 0; i < arr.length; i++) {
    const pair = arr[i].split('=');
    vars[pair[0]] = decodeURIComponent(pair[1] || '');
  }
  return vars;
}

function handleMessage(event: MessageEvent) {
  if (!allowedOrigins.includes(event.origin)) return;

  let data: any = event.data;
  let action: string | null = null;
  let parsed: any = {};
  

  // Only handle string or object with action
  if (typeof data === "string") {
    parsed = parseQueryString(data);
    
    action = parsed.action;
  } else if (typeof data === "object" && data.action) {
    action = data.action;
    parsed = data;
  }

  if (action) {
    listeners.forEach(listener => listener(parsed, event));
  }
}

export function addAuthorizeNetListener(listener: AuthorizeNetEventListener) {
  if (listeners.size === 0) {
    window.addEventListener('message', handleMessage);
  }
  listeners.add(listener);
}

export function removeAuthorizeNetListener(listener: AuthorizeNetEventListener) {
  listeners.delete(listener);
  if (listeners.size === 0) {
    window.removeEventListener('message', handleMessage);
  }
} 